import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-check-box-readonly',
  templateUrl: './check-box-readonly.component.html',
  styleUrls: ['./check-box-readonly.component.scss']
})
export class CheckBoxReadonlyComponent implements OnInit {
  @Input() value: boolean = false;
  constructor() { }
  ngOnInit(): void {
  }
}
